import dayjs from 'dayjs';
import React, { Component } from "react";
import { connect } from "react-redux";
// App Imports
// import params from "../../../setup/config/params";
import { priceFormat } from "../../../setup/helpers";
import { messageShow } from "../../common/api/actions";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { detail } from "../api/actions/query";
import "./styles.css";
import QRCode from "qrcode.react";
import routes from "../api/routes";
import IconButton from '@mui/material/IconButton';
import PrintIcon from '@mui/icons-material/Print';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';

class Print extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      QRImg: "",
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh = async () => {
    const {
      detail,
      match: {
        params: { orderId },
      },
      messageShow,
    } = this.props;
    try {
      const { data } = await detail({ orderId });
      if (data.success) {
        this.setState({
          detail: data.data,
          currencySymbol: data.data.currencydata.symbol,
        });
        document.getElementById("btn").click();
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      messageShow("Some error occurred. Please try again.");
    }
  };
  imprimir = () => {
    window.print();
  };
  back = () => {
    const { history } = this.props;

    if (history.length > 2) {
      history.goBack();
    } else {
      history.push(routes.orderList.path(1)); // Default to first page if no history
    }
  };
  handleCancel = () => {
    this.props.history.goBack()
  };
  render() {
    const fullPath = window.location.href;
    const { isLoading, detail, currencySymbol } = this.state;

    return (
      <>
        {isLoading ? (
          <BrandedLoading />
        ) : (
          detail &&
          detail.order &&
          detail.order._id && (
            <>
              <div id="ConsutaBPM">
                {/* Vendor Address Header */}
                <div style={{ textAlign: 'center', marginBottom: '20px', paddingBottom: '15px' }}>
                  <h1 style={{ margin: '0 0 10px 0', fontSize: '2em', fontWeight: 'bold', textTransform: 'uppercase' }}>{detail.vendorAddress.name}</h1>
                  <p style={{ margin: 0, fontSize: '1em', color: '#333' }}>
                    {`${detail.vendorAddress?.addressId?.street1 || ''}${detail.vendorAddress?.addressId?.street2 ? `, ${detail.vendorAddress?.addressId?.street2}` : ''}`}<br/>
                    {`${detail.vendorAddress?.addressId?.city || ''}${detail.vendorAddress?.addressId?.pincodeId?.pincode ? ` - ${detail.vendorAddress?.addressId?.pincodeId.pincode}` : ''}`}
                    {", "}{`Phone: ${detail.vendorAddress?.mobile || ''}`}
                  </p>
                  <h2 style={{ margin: '15px 0 0 0', fontSize: '1.5em', fontWeight: 'bold', textTransform: 'uppercase' }}>Order Receipt</h2>
                </div>

                {detail.order.isCancelled && (
                  <SectionPaper
                    padding
                    style={{ color: "red", paddingBottom: 0 }}
                  >
                    This order has been cancelled by the customer.
                  </SectionPaper>
                )}

                <div
                  className="printView px-2"
                  style={{ width: "99%", margin: "0 auto" }}
                >
                  <div
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'baseline',
                        marginBottom: '2px',
                      }}
                    >
                      <div /* style={{ width: "25%" }} */ >Date</div> 
                      <div style={{ textAlign: "right" /*, width: "75%" */ }}>
                        {dayjs(detail.order.createdAt).format('DD-MM-YYYY')}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'baseline',
                        marginBottom: '2px',
                      }}
                    >
                      <div /* style={{ width: "30%" }} */ >Order ID</div>
                      <div style={{ textAlign: "right" /*, width: "70%" */ }}>
                        {detail.order.id.toUpperCase()}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'baseline',
                        marginBottom: '2px',
                      }}
                    >
                      <div /* style={{ width: "25%" }} */ >Customer Name</div>
                      <div style={{ 
                        textAlign: "right", 
                        /* width: "75%", */
                        whiteSpace: "nowrap", 
                        overflow: "hidden", 
                        textOverflow: "ellipsis" 
                      }}>
                        {detail.order.userId.name}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'baseline',
                        marginBottom: '2px',
                      }}
                    >
                      <div /* style={{ width: "30%" }} */ >Address</div>
                      <div style={{ textAlign: "right" /*, width: "70%" */ }}>
                        {detail.order?.addressId?.street1}{" "}
                        {detail.order?.addressId?.street2} - {detail.order?.addressId?.city}{" "}
                        {detail.order?.pincodeId?.pincode}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: 'baseline',
                        marginBottom: '2px',
                      }}
                    >
                      <div>Mobile</div>
                      <div style={{ textAlign: "right" /*, width: "75%" */ }}>
                        {detail.order.userId.mobile}
                      </div>
                    </div>
                  </div>

                  <table
                    style={{
                      border: "1px solid black",
                      borderCollapse: "collapse",
                      marginTop: 20,
                      marginBottom: 20,
                      width: "100%",
                    }}
                  >
                    <thead>
                      <tr style={{ textAlign: "center", width: "100%" }}>
                        <th style={{ width: "60%", border: "1px solid black" }}>
                          Item
                        </th>
                        <th style={{ width: "20%", border: "1px solid black" }}>
                          Qty
                        </th>
                        <th style={{ width: "20%", border: "1px solid black" }}>
                          Price
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {detail.orderItems.map(
                        ({ _id, productId, amount, quantity }, index) => (
                          <tr key={_id} style={{ textAlign: "center" }}>
                            <td style={{ border: "1px solid black" }}>
                              {productId.name}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {quantity}
                            </td>
                            <td style={{ border: "1px solid black" }}>
                              {currencySymbol} {priceFormat(amount)}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                  <div
                    style={{
                      marginTop: 10,
                      marginLeft: "5px",
                      marginRight: "5px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ width: "40%" }}>Sub total</div>
                      <div style={{ textAlign: "right", width: "60%" }}>
                        {currencySymbol}
                        {priceFormat(detail.order.amountTotal)}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ width: "40%" }}>Delivery Charge</div>
                      <div style={{ textAlign: "right", width: "60%" }}>
                        {currencySymbol}
                        {priceFormat(detail.order.deliveryCharge || 0)} 
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ width: "25%" }}>Tax</div>
                      <div style={{ textAlign: "right", width: "75%" }}>
                        {currencySymbol}
                        {priceFormat(detail.order.taxAmount)}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ width: "25%" }}>Discount</div>
                      <div style={{ textAlign: "right", width: "75%" }}>
                        {currencySymbol}
                        {priceFormat(detail.order.discount)}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 2,
                        justifyContent: "space-around",
                      }}
                    >
                      <div style={{ width: "50%", fontWeight:'bold'  }}>Grand Total</div>
                      <div style={{ textAlign: "right", width: "50%", fontWeight:'bold' }}>
                        {currencySymbol}
                        {priceFormat(detail.order.grandTotal)}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: 4,
                      }}
                    >
                      <div style={{width: "50%", textAlign: "right"}}>{detail.order?.pincodeId?.description}</div>
                    </div>
                    <div
                      className="QRcode"
                      style={{
                        marginTop: "20px",
                        textAlign: "center",
                      }}
                    >
                      <QRCode
                        value={fullPath}
                        style={{ margin: "0 auto" }}
                        id="QRCanvas"
                        renderAs="svg"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', marginTop:'10px' }}>
                <Tooltip title="Print">
                  <IconButton id="btn" onClick={this.imprimir} color="primary" aria-label="print">
                    <PrintIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Cancel">
                  <IconButton onClick={this.handleCancel} color="error" aria-label="cancel">
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
              
            </>
          )
        )}
      </>
    );
  }
}

// Component State
function detailState(state) {
  return {
    auth: state.auth,
  };
}

export default connect(detailState, { detail, messageShow })(Print);
